// @auto-index

import description from './description.txt'
import icon from './icon.jpg'
import screenshots from './screenshots'

export { default as description } from './description.txt'
export { default as icon } from './icon.jpg'
export { default as screenshots } from './screenshots'

export default {
  description,
  icon,
  screenshots
}
